import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {dateToHumanDateStr, display24HourTime, today} from "../../shared/date.js";
import {Card, CardContent, Chip} from "@mui/material";
import Grid from "@mui/material/Grid";
import {sliceIn2} from "../../shared/transform.js";
import InstagramIcon from "@mui/icons-material/Instagram";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Divider from "@mui/material/Divider";
import {Crumbs} from "../Crumbs.jsx";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import Button from "@mui/material/Button";

const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];

const ArtistPage = () => {
    const [artist, setArtist] = useState({});
    const params = useParams();

    useEffect(() => {
        const todayDate = today();

        // Fetch artist from Strapi by artistKey, only including future events
        fetch(`${BACKEND_HOST}/artists?filters[artistKey][$eq]=${params.bandKey}&populate[]=event_artists&populate[]=event_artists.event&populate[]=event_artists.event.venue&filters[event_artists][event][date][$gte]=${todayDate}`)
            .then(res => res.json())
            .then(res => {
                const a = res.data && res.data.length > 0 ? res.data[0] : {};
                setArtist(a || {});
            });
    }, [params.bandKey]);

    // Filter out any event_artists that have event == null or are in the past
    const todayDate = today();
    const events = (artist?.event_artists || [])
        .filter(ea => ea.event != null)
        .filter(ea => ea.event.date >= todayDate);

    return (
        <Grid container>
            <Grid item xs={12}>
                <Crumbs crumbs={[
                    {title: "Artist"},
                    {title: artist.name}
                ]} />
                <Card>
                    <CardContent>
                        <span style={{fontSize: "150%"}}>{artist.name}</span>{artist.tag && <Chip size={"small"} label={artist.tag}/>}
                        {artist.instagram && <div>
                            <IconButton size={"small"} target="_blank"
                                        href={"https://instagram.com/" + artist.instagram + "/"}>
                                <InstagramIcon/>&nbsp;
                                <Link size={"small"} target="_blank">{artist.instagram}</Link>
                            </IconButton>
                        </div>}
                        {artist.venmo && <Button href={`${artist.venmo}`} startIcon={<MonetizationOnIcon />}>{artist.venmo}</Button>}

                        <Divider/>
                        <h6>Upcoming Shows</h6>
                        <Grid container>
                            {sliceIn2(events).map((halfEvents, idx) =>
                                <Grid item xs={12} md={6} style={{marginBottom: "10px"}} key={idx}>
                                    {halfEvents.map((ea, i) =>
                                        <div style={{paddingBottom: "10px"}} key={i}>
                                            <div>{dateToHumanDateStr(new Date(ea.event.date + " 12:00:00"))} @ {display24HourTime(ea.time)}</div>
                                            <div>{ea.event?.venue?.name}</div>
                                        </div>)}
                                </Grid>
                            )}
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
}

export default ArtistPage;